import { useEffect, useState } from 'react'
import { useNavigation } from 'react-router-dom'

const Progress = () => {
  const { state, location } = useNavigation()

  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setProgress(0)
  }, [location?.pathname])

  useEffect(() => {
    if (state === 'loading') {
      setProgress(10)
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 90) return oldProgress
          if (oldProgress === 100) {
            clearInterval(timer)
            return 100
          }
          const newProgress = oldProgress + 10
          return newProgress > 100 ? 100 : newProgress
        })
      }, 300)

      return () => {
        clearInterval(timer)
      }
    }
  }, [state])

  if (state !== 'loading') {
    return null
  }

  return (
    <div
      className="absolute left-0 bottom-0 h-1 translate-y-1 z-50 bg-primary transition-all duration-200 ease-in-out"
      style={{ width: `${progress}%` }}
    ></div>
  )
}

export { Progress }
